import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton } from 'components/buttons/IconButton/styles';

function IconButton({
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
  icon,
  disabled,
}) {
  return (
    <StyledButton
      onClick={onClick}
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled}
    >
      {icon}
    </StyledButton>
  );
}

IconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  icon: PropTypes.element.isRequired,
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  onMouseEnter: null,
  onMouseLeave: null,
  className: '',
  disabled: false,
};

export default IconButton;
